export const GET_CCL_KEYWORDS = 'GET_CCL_KEYWORDS ';
export const SET_CCL_KEYWORDS = 'SET_CCL_KEYWORDS';
export const ERROR_CCL_KEYWORDS = 'ERROR_CCL_KEYWORDS';
